import { Link } from "react-router-dom";

const cols = [
  { title: "Explore", links: [
    { to: "/programs", label: "Programs" },
    { to: "/destinations", label: "Destinations" },
    { to: "/packages", label: "Packages" },
    { to: "/how-it-works", label: "How It Works" },
  ]},
  { title: "Company", links: [
    { to: "/about", label: "About" },
    { to: "/partner", label: "Partner With Us" },
    { to: "/faqs", label: "FAQs" },
    { to: "/contact", label: "Contact" },
  ]},
  { title: "Legal", links: [
    { to: "/disclaimer", label: "Disclaimer" },
    { to: "/disclaimer#privacy", label: "Privacy Policy" },
    { to: "/disclaimer#terms", label: "Terms and Conditions" },
  ]},
];

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div>
          <div className="mb-4 inline-block rounded-2xl bg-white/95 p-3">
            <img
              src="/brand/logo-round.png"
              alt="StudyTrip Global — Learn. Travel. Grow."
              className="h-12 w-auto"
              loading="lazy"
            />
          </div>
          <p className="text-xs text-slate-500 leading-relaxed">
            Programs, pricing, availability, travel requirements, and destination options are subject to change. Visa and entry decisions are made solely by government authorities.
          </p>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="font-display font-bold text-white mb-4">{c.title}</h4>
            <ul className="space-y-2">
              {c.links.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-slate-400 hover:text-white transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-center md:text-left">
          <p className="text-xs text-slate-500">© 2024 StudyTrip Global. All rights reserved.</p>
          <p className="text-xs text-slate-500">StudyTrip Global is operated by Teach Me Online Inc., Canada</p>
        </div>
      </div>
    </footer>
  );
}
